import './App.css';

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Route, Routes } from 'react-router-dom';
import Header from './Header'
import Dashboard from './features/dashboard/DashboardComponent';
import Login from './features/authentication/Login';
import { ProtectedRoute, AuthenticatedRoute, AuthenticatedRouteIsAdmin, AuthenticatedProductEditor, AuthenticatedCustomerEditor } from './features/authentication/ProtectedRoute';
import User from './features/UserInfo/User';
import { ToastContainer, toast } from 'react-toastify';
import { ChangePassword } from './features/UserInfo/ChangePassword';
import ResetPasswordRequest from './features/UserInfo/ResetPasswordRequest';
import ResetPassword from './features/UserInfo/ResetPassword';
import { withTranslation } from 'react-i18next';
import { Spinner } from 'reactstrap';
import i18next from 'i18next';
import { changeLocale, unwrapError} from './backoffice/apis/axios';
import { user } from './backoffice/dtos/authentication/user';
import { getUser } from './helpers/localStorage';
import { useWindowHeight } from './app/hooks';
import PhoneHeader from './PhoneHeader';
import PromotionsTimelineBase from './features/timeline/PromotionsTimelineBase';
import { Settings } from './features/Settings/Settings';

function App()  {
  const height = useWindowHeight();
  const [user, setUser] = useState<user | undefined>()
  useEffect(()=> {
    const fetchLocale = async () => {
      try {
        await changeLocale(i18next.language);
      } catch (error: any) {
        toast(await unwrapError(error));
      }
    };
    fetchLocale();
  }, [i18next.language])

  useEffect(() => {
    function storageListener() {
        setUser(getUser())
    }
    window.addEventListener("localstorage-user-changed", storageListener)
    return () => window.removeEventListener("localstorage-user-changed", storageListener)
  }, [setUser])

  const header = useMemo(() => {
    if (height > 767) {
      return <Header />
    } else {
      return <PhoneHeader />
    }
  }, [height])

  return (
    <div className="App min-vh-100 bg-lvl-1 d-flex flex-column">
      {header}
      <React.Suspense fallback={
        <div className='d-flex vh-100 align-items-center justify-content-center'>
          <Spinner/>
        </div>
      }>
      <TransitionGroup className="d-flex flex-column flex-fill">
        <CSSTransition classNames="page" timeout={300}>
          <Routes>
            <Route path='/reset/password/request' element={<ResetPasswordRequest />} />
            <Route path='/reset/password/:token' element={<ResetPassword />} />

            <Route element={<AuthenticatedRoute user={user}/>}>
              <Route path='/login' element={<Login />} />
            </Route>

            <Route element={<ProtectedRoute user={user}/>}>
              <Route path='/dashboard' element={<Dashboard />} />

              <Route path='/promotions' element={<PromotionsTimelineBase />} />

              <Route path='/settings' element={<Settings />} />

              <Route path='/changePassword' element={<ChangePassword />} />

              <Route path='*' element={<Dashboard />} />
            </Route>
          </Routes>
        </CSSTransition>
      </TransitionGroup>
      <ToastContainer
        key='toast-container-global'
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      </React.Suspense>
    </div>
  );
}

export default withTranslation()(App);

